import { Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import type { SpecialsViewModel } from '@jane/bloom/viewModels/specials';

import { BundleCard } from './bundleCard';
import { DealQualifiedBanner } from './dealQualifiedBanner';

import styles from './bundleProgress.module.css';

type BundleProgressProps = {
  specialsProducts: SpecialsViewModel;
};

export const BundleProgress = ({ specialsProducts }: BundleProgressProps) => {
  return (
    <div className={styles['bundleProgressContainer']}>
      <div
        className={clsx(styles['title'], {
          [styles['titleQualified']]:
            specialsProducts.isUnlocked || specialsProducts.isApplied,
        })}
      >
        {/* // header bold on mobile only */}
        <Typography color="inherit" variant="h2-semibold">
          {specialsProducts.qualifyingStatusMsg}
        </Typography>
      </div>
      <div className={styles['bundleProgressCardsContainer']}>
        <div className={styles['bundleProgressCards']}>
          {specialsProducts.allQualifiedProducts.map((product, i) => (
            <BundleCard
              key={`${product.id}-${i}`}
              img={product.image_urls}
              productId={product.id}
              productName={product.name}
              priceId={product.price_id}
            />
          ))}
          {specialsProducts.remainingProducts
            ? [...Array(specialsProducts.remainingProducts)].map((_, i) => (
                <BundleCard key={`remaining-${i}`} active={i === 0} />
              ))
            : null}

          {specialsProducts.displayDiscountedProducts.map((product, i) => (
            <BundleCard
              key={`${product.id}-${i}`}
              img={product.image_urls}
              productId={product.id}
              priceId={product.price_id}
            />
          ))}
          {specialsProducts.remainingDependentProducts &&
          !specialsProducts.allowDiscountsOnRequiredProducts
            ? [...Array(specialsProducts.remainingDependentProducts)].map(
                (_, i) =>
                  specialsProducts.isUnlocked ? (
                    <BundleCard
                      active
                      dealUnlocked
                      hasDependent
                      key={`dependent-${i}`}
                    />
                  ) : (
                    <BundleCard hasDependent key={`dependent-${i}`} />
                  )
              )
            : null}
        </div>
      </div>

      {specialsProducts.isApplied && specialsProducts.discountedAmount && (
        <DealQualifiedBanner
          discountedAmount={specialsProducts.discountedAmount}
        />
      )}
    </div>
  );
};
